

















































import Vue from "vue";
import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import { LineStopSyncSchedule } from "../models/LineStopSyncSchedule";

export default Vue.extend({
  mixins: [permission, pagination],
  data() {
    const schedules: LineStopSyncSchedule[] = [];

    return {
      schedules
    };
  },
  computed: {
    hasLineStopSyncPermission() {
      return (this as any).hasPermission(PermissionName.LINE_STOP_SYNC);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getLineStopSyncs()]);
  },
  methods: {
    async getLineStopSyncs() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.lineUseCase.getLineStopSyncs(form);

        this.schedules = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToLineStopSyncCreatePage() {
      this.$router.push({ name: "LineStopSyncCreatePage" });
    }
  }
});
